const headers = {
  name: "Purchase refund",
  navigate: {
    path: [
      {
        name: "Refund",
        path: "/app/purchases/refund",
      },
      {
        name: "Add",
        path: "",
      },
    ],
  },
};

export default headers;
